import type * as Sentry from "@sentry/nextjs";
import { environment } from "@/environment/environment";

export const sentrySharedConfigOptions: Parameters<typeof Sentry.init>[0] = {
  debug: false,
  dsn: environment.NEXT_PUBLIC_SENTRY_DSN,
  environment: environment.VERCEL_ENV,
  tracesSampleRate: 1,
};
